import { useScreenSize } from '@hooks';
import { theme, Typography } from '@styles';
import { ReactComponent as ErrorIcon } from '@svgs/toast-error.svg';
import { ReactComponent as SuccessIcon } from '@svgs/toast-success.svg';
import { ReactComponent as WarningIcon } from '@svgs/toast-warning.svg';
import { bool, oneOf, string } from 'prop-types';
import React from 'react';

import { Icon } from '../Icon';
import { SlidingComponent } from './Popup.layoutProps';

const getSvgIcon = (variant) => {
  switch (variant) {
    case 'success':
      return SuccessIcon;
    case 'warning':
      return WarningIcon;
    case 'error':
      return ErrorIcon;
    default:
      return ErrorIcon;
  }
};

const Popup = ({ isPopupVisible, text, variant }) => {
  const { isTabletSM } = useScreenSize();
  const svgIcon = getSvgIcon(variant);

  return (
    <SlidingComponent
      alignItems="center"
      backgroundColor={theme.colors.schoolBusYellow[100]}
      gap={16}
      height="auto"
      m={isTabletSM ? 'auto' : 16}
      position="fixed"
      px={isTabletSM ? 10 : 16}
      py={isTabletSM ? 16 : 24}
      top={isPopupVisible ? '0px' : '-500px'}
      transition="3s"
      width={isTabletSM ? '100%' : 480}
      zIndex="100"
    >
      <Icon height={56} SVG={svgIcon} width={56} />
      <Typography variant="MS-bold-s18-lh19">{text}</Typography>
    </SlidingComponent>
  );
};

Popup.propTypes = {
  isPopupVisible: bool,
  text: string,
  variant: oneOf(['success', 'warning', 'error']),
};

Popup.defaultProps = {
  isPopupVisible: false,
  text: '',
  variant: 'error',
};

export default Popup;
